import { render, staticRenderFns } from "./InvoiceList.vue?vue&type=template&id=4a8f3779&scoped=true&"
import script from "./InvoiceList.vue?vue&type=script&lang=ts&"
export * from "./InvoiceList.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceList.vue?vue&type=style&index=0&id=4a8f3779&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8f3779",
  null
  
)

export default component.exports